<template>
<div>
	<div class="infomationTable">
		<table class="table">
		    <tr>
			    <th>序号</th>
			    <th>获奖时间</th>
			    <th>获奖名称</th>
			    <th>颁发机构</th>
			    <th>操作</th>
		    </tr>
		    <tr v-for="(item,index) in formList">
		        <td>
		        	<div class="label">序号</div>
		        	{{index+1}}
		        </td>
		        <td>
		        	<div class="label">获奖时间</div>
		        	{{item.awardTime}}
		        </td>
		        <td>
		        	<div class="label">获奖名称</div>
		        	{{item.title}}
		        </td>
		        <td>
		        	<div class="label">颁发机构</div>
		        	{{item.authority}}
		        </td>
		      	<td>
		      		<div class="label">操作</div>
		      		<div class="edit" @click="edit(item.id)">编辑</div>
		      	</td>
		    </tr>
		</table>
	</div>
	
	<!-- 添加按钮 -->
	<div class="addBtn" @click="add"></div>
	
	<!-- 编辑、新增的弹窗 -->
	<div class="infomationAddEdit" v-if="popShow">
		<div class="mask"></div>
		<div class="form">
			<div class="close" @click="cancel"></div>
			<div class="tit f-16 fb">
				<template v-if="addOrEdit==1">
					新增
				</template>
				<template v-if="addOrEdit==2">
					编辑
				</template>	
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>获奖时间</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.awardTime"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择获奖时间">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>获奖名称</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.title" name="title" placeholder="请填写获奖名称">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>颁发机构</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.authority" name="authority" placeholder="请填写颁发机构">
				</div>
			</div>
			

	      	<div class="btnBox">
				<div class="btn btn1" @click="save">保存</div>
				<div class="btn btn2" @click="cancel">取消</div>
	      	</div>
		</div>
	</div>
</div>
</template>
<script>
import { 
  awardsList,
  awardsAdd,
  awardsEdit,
  awardsDelete,
  awardsQueryById
} from "@/api/tableapi";

export default {
	name: 'tableawards',
	props:{
		isshow: {
	      	type: Boolean,
  			default: {}
	    }
	},
	watch: {
	    isshow: {
	      immediate: true,
	      handler(newval,oldval) {
	        if (newval) {
	        	this.initData()
	        }
	      }
	    },
	},
	data(){
		return{
		    formList:[],
		    addOrEdit:1,   //1是新增2是编辑
		    popData:{
		    	awardTime:'',
		    	title:'',
		    	authority:''
		    },
		    popShow:false,

		    xueliOptions:[]
		}
	},
	created(){
		this.initData()
	},
  	methods:{
  		//获取当前表格的数据
  		initData(){
  			let that=this
  			awardsList("").then(res=>{
              if (res.success) {               
                that.formList=res.result.records
              }
            })
        },

        //添加
	    add(){
	    	let that=this
	    	that.addOrEdit=1
	    	that.popData={
		    	awardTime:'',
		    	title:'',
		    	authority:''
		    }

		    that.popShow=true
	    },

	    //编辑
	    edit(id){
	    	let that=this
	    	awardsQueryById(id).then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.addOrEdit=2

		          if(res.result.awardTime!=''&&res.result.awardTime!=null){
		            let awardTime=res.result.awardTime
		            res.result.awardTime=awardTime.split(" ")[0]
		          }

		          that.popData=res.result

		          that.popShow=true
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    },

	    save(){
	    	let that=this

		    //验证，表格结构数据中有必填和校验正则
		    if (that.popData.awardTime==''||that.popData.awardTime==null) {
		    	that.$message.error('请选择获奖时间!');
		    	return false
		    }

		    if (that.popData.title==''||that.popData.title==null) {
		    	that.$message.error('请填写获奖名称');
		    	return false
		    }

		    if (that.popData.authority==''||that.popData.authority==null) {
		    	that.$message.error('请填写颁发机构');
		    	return false
		    }

		    //通过验证
		    that.popData.awardTime+=' 00:00:00'
		    //添加
		    if (that.addOrEdit==1) {
		    	awardsAdd(that.popData).then(res=>{
	              if (res.success) {
	              	that.initData()            
	                that.$message.success('添加成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
		    //编辑
		    if (that.addOrEdit==2) {
		    	awardsEdit(that.popData).then(res=>{
	              if (res.success) { 
	              	that.initData()              
	                that.$message.success('编辑成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
	    },

	    cancel(){
	    	let that=this
	    	that.popShow=false
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tableawards/index.vue